export default __webpack_public_path__ + "static/142-f04ade2a60d8978f5a592b077f6a9ab6.jpg";